import {t} from 'i18next';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import ImageComponent from '../../components/inputs/ImageComponent';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import InputTextEditorComponent from '../../components/inputs/InputTextEditorComponent';
import YesNoDialog from '../../components/YesNoDialog';
import ActionService from '../../services/ActionService';
import FileUploadService from '../../services/FileUploadService';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import ActionCreateRequest from './ActionCreateRequest';
import {default as ActionDetailsResponse} from './ActionDetailsResponse';
import Constants from '../../utils/constants';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import TranslationUtils from '../../utils/TransaltionUtils';
import { Panel } from 'primereact';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import PublishToCompaniesDialog from '../../components/PublishToCompaniesDialog';
import PublishedToCompaniesList from '../../components/PublishedToCompaniesList';

class ActionContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new ActionService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            steps:[],
            isTourOpen: false,
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: {
                translations: [],
                latitude: 54.312795,
                longitude: 18.651946,
            },
            actionTypes: [],
            parameters: [],
            showPublishDialog: false,
            showPublishToCompaniesDialog: false,
            showConfirmRemoveDialog: false,
            markers: [{position: {lat: 54.312795, lng: 18.651946}}],
            circleCenter: [54.312795, 18.651946],
            markersInitialized: false,
            zoom: 10,
            initialCoordinates: {
                lat: Constants.initialLatitude,
                lng: Constants.initialLongitude,
            },
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.verificationInstructionRef = React.createRef();
        this.renderLanguages = this.renderLanguages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handlePublishToCompanies = this.handlePublishToCompanies.bind(this);
        this.publish = this.publish.bind(this);
        this.publishToCompanies = this.publishToCompanies.bind(this);
        this.componentRef = React.createRef();
        this.uploadIconHandler = this.uploadIconHandler.bind(this);
        this.uploadPhotoHandler = this.uploadPhotoHandler.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                element: ActionDetailsResponse.copy(this.state.element, data),
                markers: data.latitude && data.longitude ? [{position: {lat: data.latitude, lng: data.longitude}}] : this.state.markers,
                circleCenter: data.latitude && data.longitude ? [data.latitude, data.longitude] : this.state.circleCenter,
            },
            () => {
                this.initAfterSetElement();
            }
        );
        if (data.status === 'ACTIVE' || data.status === 'REMOVED') {
            this.setState({
                viewMode: 'VIEW',
            });
        }
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }
    componentDidUpdate(){
        super.componentDidUpdate();
        this.initSteps();
    }
    initBeforeSetElement() {
        this.initSteps();
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new ActionCreateRequest(supportedLocales)
                            : new ActionDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
        this.enumService
            .getLocalizedEnumList('ActionType')
            .then((actionTypes) =>
                this.setState({
                    actionTypes,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('action.actionTypesError'));
            });
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderLanguages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }
    canViewTour(){
        return this.props.viewMode === 'NEW' || this.props.viewMode === 'EDIT'; 
    }
    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const editHref = `${editUrl}/${this.state.element?.id}/${locale}`;
        const detailHref = `${detailUrl}/${this.state.element?.id}/${locale}`;
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(detailHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailHref));
                },
                className: 'gray',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.props.viewMode === 'VIEW' && this.state.element.status?.value === 'DRAFT',
            },
            {
                label: t('global.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status?.value === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: 'Publikuj do wielu',
                onClick: this.handlePublishToCompanies,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered:
                    this.state.element.status?.value === 'DRAFT' &&
                    viewMode === 'VIEW' &&
                    this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR'),
            },
            {
                label: t('global.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: this.props.viewMode === 'VIEW' || this.props.viewMode === 'EDIT',
            },
        ];
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }

    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeQRCode(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('action.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch((err) => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(err.message, 10000);
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        console.log('publish');
        this.setState({
            showPublishDialog: true,
        });
    }

    handlePublishToCompanies() {
        this.setState({
            showPublishToCompaniesDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            if (this.validator.allValid()) {
                this.blockUi();
                if (this._isMounted) {
                    this.service
                        .publish(this.state.elementId)
                        .then(() => {
                            const {backUrl} = this.props;
                            this.blockUi();
                            this.persistMessage('success', '', t('action.publishSuccess'));
                            // window.location.href = backUrl;
                            this.props.history.push(backUrl);
                        })
                        .catch((err) => {
                            this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                            this.setState({showPublishDialog: false});
                            this.unblockUi();
                        });
                } else {
                    this.setState({showPublishDialog: false});
                }
            } else {
                this.setState({showPublishDialog: false});
                this.validator.showMessages();
                // rerender to show messages for the first time
                this.scrollToError = true;
                this.forceUpdate();
            }
        }
    }

    publishToCompanies(externalIds) {
        this.scrollToTop();
        if (!this.validator.allValid()) {
            this.setState({showPublishToCompaniesDialog: false});
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
            return;
        }

        this.blockUi();
        this.service
            .publishToCompanies(this.state.elementId, {externalIds})
            .then(() => {
                const {backUrl} = this.props;
                this.persistMessage('success', '', 'Akcja zostala opublikowana do wybranych firm.');
                this.props.history.push(backUrl);
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                this.setState({showPublishToCompaniesDialog: false});
                this.unblockUi();
            });
    }

    getAddSucces() {
        return t('action.createSuccess');
    }

    getUpdateSucces() {
        return t('action.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        if(element.actionType){
            element.actionType = element.actionType.enumValue;
        }
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;
        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));
        this.scrollToTop();
        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderLanguages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status?.value === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('action.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('action.publishBody')}</span>
                </YesNoDialog>
                <PublishToCompaniesDialog
                    visible={this.state.showPublishToCompaniesDialog}
                    header='Publikuj akcje do wielu firm'
                    body='Wybierz firmy, do ktorych chcesz opublikowac ta akcje.'
                    onHide={() => {
                        this.setState({showPublishToCompaniesDialog: false});
                    }}
                    onPublish={this.publishToCompanies}
                />
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('action.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('action.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'action-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('action.listTitle'), url: '/action-list'},
            {name: t('action.details.header'), url: ``},
        ];
        
    }
    initSteps() {
        const {locale} = this.state;
        const stepStyle = {backgroundColor: '#cce4fd'};
        this.steps = [];
        const addStep = (selector, content) => {
            this.steps.push({selector, content, style: stepStyle});
        };
        const stepsInfo = TranslationUtils.getStepInfo("action");
        addStep(`#${locale}-title`, () => <div><b>{stepsInfo.title.title}</b> - {stepsInfo.title.description}</div>);
        addStep('#coinsToEarn', () => (<div><b>{stepsInfo.coinsToEarn.title}</b> - {stepsInfo.coinsToEarn.description}</div>)); 
        addStep('#activeFrom-activeTo', () => (<div><b>{stepsInfo.activeDates.title}</b> - {stepsInfo.activeDates.description}</div>));
        addStep('#image', () => (<div><b>{stepsInfo.image.title}</b> - {stepsInfo.image.description}</div>));
        addStep('#description', () => (<div><b>{stepsInfo.description.title}</b> - {stepsInfo.description.description}</div>));
    }
    renderDetails() {
        const {elementId} = this.state;
        const {locale} = this.state;
        
        return (
            <React.Fragment>
                <div className='row'>
                    <PublishedToCompaniesList
                        companies={this.state.element?.publishedToCompanies}
                        rendered={this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR')}
                    />
                    <InputTextComponent
                        id={`${locale}-title`}
                        name='title'
                        label={t('action.title')}
                        colClass='col-md-3'
                        value={this.state.element?.translations[locale]?.title}
                        validator={this.validator}
                        validators='required|max:128'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        stateField={`element.translations[${locale}]`}
                        validateViewMode
                        idForViewValidation
                    />
                    <InputNumberComponent
                        id='coinsToEarn'
                        name='coinsToEarn'
                        label={t('action.coinsToEarn')}
                        colClass='col-md-3'
                        min={0}
                        value={this.state.element.coinsToEarn}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                    />
                    <InputCalendarRangeComponent
                        id=""
                        key={'active'}
                        idFrom={'activeFrom'}
                        idTo={'activeTo'}
                        nameTo={'activeTo'}
                        nameFrom={'activeFrom'}
                        label='' 
                        labelFrom={t('action.activityRangeFrom')}
                        labelTo={t('action.activityRangeTo')}
                        colClass='col-6'
                        from={this.state.element.activeFrom}
                        to={this.state.element.activeTo}
                        validator={[this.validator, this.validatorDraft]}
                        onChange={this.handleChange}
                        viewMode={this.viewMode()}
                        showTime
                        showIcon
                        validatorsTo={`required|date|after_or_equal_datetime~${moment(
                            this.state.element.activeFrom ? this.state.element.activeFrom : new Date()
                        )
                            .format('DD-MM-YYYY HH:mm')
                            .toString()}`}
                        placeholderFrom='dd-mm-rrrr GG:MM'
                        placeholderTo='dd-mm-rrrr GG:MM'
                        validateViewMode
                        dateFormatMoment='DD-MM-YYYY HH:mm'
                        validatorsToType='after_or_equal_datetime'
                    />
                    <div className='col-md-12 col-sm-12'>
                        <div className='form-group'>
                            <div className=' row p-label'>
                                <label>{t('action.photo')}</label>
                            </div>
                            <ImageComponent
                                key='action-photo'
                                srcUrl={`${this.service.getPath()}/attachment/${
                                    this.state.element?.photo?.uuid
                                }?token=${this.authService?.getToken()}`}
                                alt='Action photo'
                                handleRemove={(e) => {
                                    this.setState((prevState) => ({
                                        element: {
                                            ...prevState.element,
                                            photo: null,
                                            removePhoto: true,
                                        },
                                    }));
                                }}
                                notValidImageTypeErrorMessage={() => {
                                    this.showErrorMessage(t('image.notValidImageType'));
                                }}
                                errorMessage={this.showErrorMessage}
                                imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                fileSizeToTranslation={this.state.fileSizeToTranslation}
                                attachment={this.state.element.photo}
                                setFile={this.uploadPhotoHandler}
                                t={t}
                                required={true}
                                validator={this.validator}
                                viewMode={this.viewMode()}
                                fileUploadService={this.fileUploadService}
                            />{' '}
                        </div>
                    </div>

                    <InputTextEditorComponent
                        colClass='col-xl-12'
                        id='description'
                        name='description'
                        key={`description-${this.viewMode()}`}
                        value={this.state.element?.translations[this.state.locale]?.description}
                        label={t('action.description')}
                        validator={this.validator}
                        validators='required'
                        rows='15'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        disabled={this.viewMode() === 'VIEW' ? true : false}
                        autoResize
                        editorRef={this.editorRef}
                        externalPhotos={true}
                        photos={this.state.element.photos}
                        photoUrl={`${this.service.getPath()}/photo/${elementId}`}
                        photoUploadUrl={`${this.fileUploadService.getPath()}/`}
                        photoLabel='fileName'
                        photoName='uuid'
                        handleError={this.onUploladError}
                        restrictExt={false}
                        token={this.authService.getToken()}
                        photoVarName='photos'
                        stateField={`element.translations[${this.state.locale}]`}
                    />
                </div>
                <div className='mb-2'></div>
            </React.Fragment>
        );
    }
    uploadIconHandler(uploadedFile) {
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                iconTemporaryFileUrl: uploadedFile.uuid,
            },
        }));
    }
    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
            this.setState((prevState) => ({
                uploadedFile,
                element: {
                    ...prevState.element,
                    photoTemporaryFileUrl: uploadedFile?.uuid,
                },
            }));
        }
    }
    handleMarkerDrag(coordinates, markerIndex) {
        this.handleCoordinatesChange(coordinates);
    }
    handleCoordinatesChange(position) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                latitude: position.lat,
                longitude: position.lng,
            },
            circleCenter: [position.lat, position.lng],
        }));
    }
}

ActionContainer.defaultProps = {
    backUrl: '/action-list',
    editUrl: '/action/edit',
    detailUrl: '/action/details',
    lazy: true,
};

ActionContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ActionContainer));
